/**
 * @file pages/Services.jsx
 * @description Services page displaying all travel services offered
 * by Nikaba Travels using the ServicesSection component.
 */

import React from 'react';
import ServiceSection from '../Components/Sections/ServicesSection';


import WhyChooseUs from "../Components/Sections/WhyChooseUs";

import Header from '../Components/Layouts/Header';
import NikabaFooter from '../Components/Layouts/Footer';


function Services() {

  
  return (
    <div className="bg-gray-100 text-gray-900 pt-24">
      <Header />
      <ServiceSection />
      <WhyChooseUs />
      <NikabaFooter />
    </div>
  );
}

export default Services;